export const aboutData = {
    title: "Who I am",
    description1: "Hi, I am Abdelrahman, I like web design and development.",
    description2: "I like dealing with colors, fonts, images, animations, and layouts. I'd love and try my best to build good functional, attractive, and great looking products that give all the users, a comfortable, smooth, and responsive experience.",
    image: 1
}
